import { HTMLAttributeAnchorTarget } from 'react';
import styles from './SubmitButton.module.scss';
import classNames from 'classnames/bind';

const cx = classNames.bind(styles);

interface SubmitButtonProps {
  text: string;
  isButton: boolean;
  onClick?: () => void;
  id?: string;
  href?: string;
  className?: string;
  target?: HTMLAttributeAnchorTarget;
  rel?: string;
}

export default function SubmitButton({
  text,
  isButton = true,
  onClick,
  id,
  href,
  className,
  target,
  rel,
}: SubmitButtonProps): JSX.Element {
  return isButton ? (
    <button
      className={cx('root', className && className)}
      onClick={onClick}
    >
      {text}
    </button>
  ) : (
    <a
      id={id}
      className={cx('root', className && className)}
      href={href}
      target={target}
      rel={rel}
    >
      {text}
    </a>
  );
}
